export const typesToDo = {
  add: "[to-do] ADD",
  list: "[to-do] LIST",
  edit: "[to-do] EDIT",
  delete: "[to-do] DELETE",
};
